window.qualityReport = {
  weights: [],
  currwt: [],
  fqrs: [],
  qrID: [],
  uRL: "",

  initialize: function(url, qrid, wts, fparams){
    qualityReport.weights = wts;
    qualityReport.fqrs = fparams;
    qualityReport.qrID = qrid;
    qualityReport.uRL = url;

    qualityReport.fetchDatafromLocalStore();
    qualityReport.startAndCancelStep();
    qualityReport.weightCalc();
    qualityReport.fqrCalc();
  },

  fetchDatafromLocalStore: function(){
    qualityReport.connectIndexeddb(function(l_db) {
      var tx = l_db.transaction('qreports', 'readwrite');
      var wotx = tx.objectStore('qreports').get(qualityReport.qrID + "_1");
      wotx.onsuccess = function() {
        console.log("Reading weights");
        if(typeof wotx.result != 'undefined' && wotx.result.length > 0){
          qualityReport.weights = wotx.result;
        }
        qualityReport.refreshWeights();
      };
      var qrotx = tx.objectStore('qreports').get(qualityReport.qrID + "_2");
      qrotx.onsuccess = function() {
        console.log("Reading Quality")
        if(typeof qrotx.result != 'undefined' && qrotx.result.length > 0){
          qualityReport.fqrs = qrotx.result;
        }
        
        $("form#fqr #fruitcount").html(qualityReport.fqrs.length + 1);
      };
    });
  },

  startAndCancelStep: function(){
    $("a.js-action").click(function(e){
      $("#step_0").hide();
      $("#step_" + this.dataset.step).show();
      e.preventdefault;
    });

    $("a.js-cancelbtn").click(function(e){
      qualityReport.completeStep(this.dataset.step);
      e.preventdefault;
    });

    $("a.js-actionbtn").click(function(e){
      if(this.dataset.step == 1){
        qualityReport.confirmAndSave(qualityReport.saveWeights);
      }else if(this.dataset.step == 2){
        qualityReport.confirmAndSave(qualityReport.saveQuality);
      }
      e.preventdefault;
    });
  },

  completeStep: function(id){
    $("#step_0").show();
    $("#step_" + id).hide();
  },

  confirmAndSave: function(callback){
    if(confirm('Are sure you want to save?')){
      callback();
    };
  },

  saveQuality: function(){
    var data = JSON.stringify({quality_report: {item_quality: {qr: qualityReport.fqrs, time: new Date().getTime()}}});
    qualityReport.saveQRData(data, '2');
  },

  saveWeights: function(){
    var data = JSON.stringify({quality_report: {item_weight: {wt: qualityReport.weights, time: new Date().getTime()}}});
    qualityReport.saveQRData(data, '1');
  },

  saveQRData: function(data, step){
    fetch(qualityReport.uRL, {
      method: 'post',
      body: data,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': Rails.csrfToken()
      },
      credentials: 'same-origin'
    }).then(function(response) {
      qualityReport.completeStep(step);
      $("a.js-action[data-step='" +step + "']").removeClass("btn-info");
      $("a.js-action[data-step='" +step + "']").removeClass("btn-primary");
      $("a.js-action[data-step='" +step + "']").addClass("btn-white");
      qualityReport.removeFromDB(qualityReport.qrID + "_" + step);

    }).then(function(data) {
      console.log(data);
    });
  },

  fqrCalc: function(){
    $("form#fqr #fruitcount").html(qualityReport.fqrs.length + 1);
    $("form#fqr .fqrbtn input").click(function(e){
      var checkedRadios =  $("form#fqr input[type='radio']:checked").length;
      if(checkedRadios == 8){
        $("form#fqr #fqrbtn-next").show();
      }
    });
  },

  nextFqr: function(){
    var unindexed_array = $("form#fqr").serializeArray();
    var indexed_array = {};

    $.map(unindexed_array, function(n, i){
      indexed_array[n['name']] = n['value'];
    });

    qualityReport.fqrs.push(indexed_array);
    qualityReport.saveToDB(qualityReport.fqrs, qualityReport.qrID + "_2");

    $("form#fqr")[0].reset();
    $("form#fqr .fqrbtn").removeClass('active');
    $("form#fqr #fqrbtn-next").hide();
    $("form#fqr #fruitcount").html(qualityReport.fqrs.length + 1);
  },

  weightCalc: function(){
    $("#allwts").html(qualityReport.weights.join(","));

    $("a.kpad").click(function(e){
      if(this.dataset.key == -1){
        if(qualityReport.currwt.length == 3){
          qualityReport.weights.pop();
        }
        qualityReport.currwt.pop();
      }else{
        if(qualityReport.currwt.length == 3){
          qualityReport.currwt = [];
        }
        qualityReport.currwt.push(this.dataset.key);  
      }
      
      qualityReport.refreshWeights();
      qualityReport.saveToDB(qualityReport.weights, qualityReport.qrID + "_1");

      e.preventdefault;
    });
  },

  refreshWeights: function(){
    var wtstr = qualityReport.currwt.join("");
    if(qualityReport.currwt.length == 3){
      qualityReport.weights.push(wtstr);
    }else if(qualityReport.currwt.length == 2){
      wtstr = "0" + wtstr;
    }else if(qualityReport.currwt.length == 1){
      wtstr = "00" + wtstr;
    }else if(qualityReport.currwt.length == 0){
      wtstr = "000";
    }

    $("#currwt h1").html(wtstr);
    $("#allwts").html(qualityReport.weights.join(","));
  },

  saveToDB: function (value,key) {
    qualityReport.connectIndexeddb(function(l_db) {
      var tx = l_db.transaction('qreports', 'readwrite');
      tx.objectStore('qreports').put(value, key);
    });
  },

  removeFromDB: function (key) {
    qualityReport.connectIndexeddb(function(l_db) {
      var tx = l_db.transaction('qreports', 'readwrite');
      tx.objectStore('qreports').delete(key);
    });
  },

  connectIndexeddb: function(callback) {
    var open = indexedDB.open("vgcrmdb", 1);
    open.onupgradeneeded = function() {
      var l_db = open.result;
      l_db.createObjectStore('qreports');
    };
    open.onsuccess = function() {
      var l_db = open.result;
      callback(l_db);
    };
    open.onerror = function() { console.log(open.error); };
  }
};